export const CHART_MARGIN_RATIO = 0.08;
export const CHART_DEFAULT_MARGIN = 1;
export const TIMELINE_CHART_HEIGHT = 300;
export const SEARCH_DEBOUNCE_DELAY = 300;
